pnx-photo-viewer {
	position: relative;
	display: block;
}

/* Maximized components */
pnx-photo-viewer .pnx-psv {
	position: absolute;
	inset: 0;
	z-index: 0;
}

/* No PSV loader */
pnx-photo-viewer .psv-loader {
	display: none;
}

/* Cornered grid layout */
pnx-photo-viewer pnx-cornered-grid::part(corner-top-left),
pnx-photo-viewer pnx-cornered-grid::part(corner-top),
pnx-photo-viewer pnx-cornered-grid::part(corner-top-right),
pnx-photo-viewer pnx-cornered-grid::part(corner-bottom-left),
pnx-photo-viewer pnx-cornered-grid::part(corner-bottom),
pnx-photo-viewer pnx-cornered-grid::part(corner-bottom-right) {
	gap: 10px;
	padding: 10px;
}

@media screen and (max-width: 576px) {
	pnx-photo-viewer pnx-cornered-grid::part(corner-top-right) {
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-start;
	}

	pnx-photo-viewer pnx-cornered-grid::part(corner-top-left) {
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
	}
}

/* Hidden widgets on sequence play */
pnx-photo-viewer.pnx-playing pnx-bottom-drawer,
pnx-photo-viewer.pnx-playing pnx-widget-legend,
pnx-photo-viewer.pnx-playing pnx-widget-zoom {
	display: none;
}

/* Override legend positioning */
@media screen and (min-width: 576px) {
	pnx-photo-viewer pnx-widget-legend:not([light="true"]) {
		position: absolute;
		top: 10px;
		width: 100%;
	}
}

/* Hidden widgets on grid toggled */
pnx-photo-viewer .psv-virtual-tour-arrows {
	transition: opacity 0.25s ease-in-out;
	opacity: 100%;
}
pnx-photo-viewer.pnx-grid-toggled .psv-virtual-tour-arrows {
	opacity: 0%;
}
pnx-photo-viewer.pnx-grid-toggled .psv-virtual-tour-arrows button {
	pointer-events: none;
	cursor: unset;
}